import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {
  ApiService,
  ActionPlanPluginService,
  ActionPlanDataService,
  LanguageService
} from '../../shared/services/index';
import { ActionPlanPlugin, Icons } from '../../shared/models/index';
import { Observable } from 'rxjs';

@Injectable()
export class DiscussionPluginService extends ActionPlanPluginService {
  public typeKeys: any = [
    { value: 0, label: 'plugins.discussion.customer' },
    { value: 1, label: 'plugins.discussion.internal-service' }
  ];
  public types: any = [];

  constructor(
    protected apiService: ApiService,
    protected actionPlanDataService: ActionPlanDataService,
    private language: LanguageService
  ) {
    super(apiService, actionPlanDataService);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  public addComment(actionPlanId: string, actionPlanItemId: string, pluginId: string, comment: string, type: number) {
    const url =
      '/actionplans/' +
      actionPlanId +
      '/actionplanitems/' +
      actionPlanItemId +
      '/plugins/discussion/' +
      pluginId +
      '/addcomment';

    return this.apiService.post(url, { Comment: comment, Type: type }).pipe(
      map((res: ActionPlanPlugin) => {
        this.actionPlanDataService.processIcons(
          true,
          Icons.getIconByName(Icons.discussionCommentIconName),
          actionPlanId,
          actionPlanItemId
        );
        return this.actionPlanDataService.updatePlugin(actionPlanId, res);
      })
    );
  }

  public deleteComment(actionPlanId: string, actionPlanItemId: string, pluginId: string, commentId: string) {
    const url =
      '/actionplans/' +
      actionPlanId +
      '/actionplanitems/' +
      actionPlanItemId +
      '/plugins/discussion/' +
      pluginId +
      '/comments/' +
      commentId +
      '/deletecomment';
    return this.apiService.delete(url).pipe(
      map((res: ActionPlanPlugin) => {
        this.actionPlanDataService.processIcons(
          res.config.Comments.length > 0,
          Icons.getIconByName(Icons.discussionCommentIconName),
          actionPlanId,
          actionPlanItemId
        );
        return this.actionPlanDataService.updatePlugin(actionPlanId, res);
      })
    );
  }

  public editComment(
    actionPlanId: string,
    actionPlanItemId: string,
    pluginId: string,
    commentId: string,
    comment: string,
    type: number
  ) {
    const url =
      '/actionplans/' + actionPlanId + '/actionplanitems/' + actionPlanItemId + '/plugins/discussion/' + pluginId;
    return this.apiService.post(url, { Id: commentId, Comment: comment, Type: type }).pipe(
      map((res: ActionPlanPlugin) => {
        return this.actionPlanDataService.updatePlugin(actionPlanId, res);
      })
    );
  }

  public getTypes() {
    return this.types;
  }

  public applyTranslations() {
    this.types = [];
    this.copyTranslationValues(this.typeKeys, this.types, this.language);
  }
}
